// extracted by mini-css-extract-plugin
export default {"button":"CustomDropdown_button__CPe8T","dropdown_wrapper":"CustomDropdown_dropdown_wrapper__ZrQRY"};